import { type AbstractControl, type ValidatorFn, type ValidationErrors } from '@angular/forms';

export function accountNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value) {
      if (!/^[0-9]*$/.test(value)) {
        return { invalidAccount: true };
      }
    }
    return null;
  };
}
